import React, { useEffect } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { storeCampaignDetails, initializeCampaignCleanup } from './helper/campaignUtils';
import { UTMSourceProvider } from './components/Context/UTMSourceProvider';
import Routes from './Routes/routes';
import Header from './layout/Header/Header';
import Footer from './layout/Footer/Footer';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
// import CookieConsentModal from '../src/pages/CookieConsentModal.jsx';
import Chatbot from './components/ChatBot/Chatbot';
import WhatsAppWidget from './components/WhatsAppWidget/WhatsAppWidget';

import DynamicDestinationHeader from './layout/DynamicDestinationHeader/DynamicDestinationHeader';
import GlobalReviewsSection from './components/Home/ReviewCommonCard/GlobalReviewsSection';
import DynamicFaqSection from './components/DynamicDestination/DynamicFaqSection';

const App = () => {
  const location = useLocation();
  const { pathname } = location;

  const normalizedPath = pathname.replace(/\/$/, '');

  const isDynamicDestinationRoute = /^\/destination\/[^/]+(\/.*)?$/.test(normalizedPath);
  const isDestinationLanding = /^\/destination\/[^/]+$/.test(normalizedPath);
  const isVacationSpotRoute = normalizedPath.endsWith('/vacation-spot');

  useEffect(() => {
    storeCampaignDetails();
    const cleanup = initializeCampaignCleanup();
    return () => cleanup();
  }, []);

  // Prevent browser from restoring previous scroll (e.g. staying on Reviews after reload)
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const forceTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    const isReload = performance.getEntriesByType('navigation')[0]?.type === 'reload';

    if (isDestinationLanding && isReload) {
      sessionStorage.removeItem('dynamicDestinationMenu');
      forceTop();
      const timers = [0, 100, 300, 700, 1200].map((delay) => setTimeout(forceTop, delay));
      return () => timers.forEach(clearTimeout);
    }

    const onPageShow = (event) => {
      if (event.persisted && isDestinationLanding) {
        sessionStorage.removeItem('dynamicDestinationMenu');
        forceTop();
      }
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, [isDestinationLanding]);

  return (
    <>
      <ToastContainer />

      {pathname !== '/' && !isDynamicDestinationRoute && <Header />}

      {isDynamicDestinationRoute && <DynamicDestinationHeader />}

      <UTMSourceProvider>
        <Routes />
      </UTMSourceProvider>

      {!isVacationSpotRoute && <GlobalReviewsSection />}

      {isDestinationLanding && <DynamicFaqSection />}

      <WhatsAppWidget />
      <Chatbot />
      <Footer />
      <ScrollToTop />
    </>
  );
};

export default App;
